
import React, { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import moment from 'moment';

import './DateDropdown.scss';

const DateDropdown = ({ dateRange, setDate, end }) => {
  const maxYear = new Date().getFullYear();
  const years = [];
  for (let i = maxYear; i >= 2000; i--) {
    years.push(i);
  }
  const [openMonth, setOpenMonth] = useState(false);
  const [openYear, setOpenYear] = useState(false);

  const date = end ? dateRange[1] : dateRange[0];

  const handleSetDate = (d) => {
    if (end) {
      setDate([dateRange[0], d]);
    } else {
      setDate([d, dateRange[1]]);
    }
  }

  const handleMonthChange = (m) => { handleSetDate(date.month(m)) }

  const handleYearChange = (y) => { handleSetDate(date.year(y)) }

  return (
    <React.Fragment>
      <Dropdown isOpen={openMonth} toggle={() => setOpenMonth(!openMonth)}>
        <DropdownToggle className="btn btn-secondary dropdown-btn" caret>
          {date.format('MMMM')}
          <i className="mdi mdi-chevron-down"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-scrollable">
          {moment.months().map((month, i) => (
            <DropdownItem key={i} onClick={() => handleMonthChange(i)}>{month}</DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
      <Dropdown isOpen={openYear} toggle={() => setOpenYear(!openYear)}>
        <DropdownToggle className="btn btn-secondary dropdown-btn" caret>
          {date.format('YYYY')}
          <i className="mdi mdi-chevron-down"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-scrollable">
          {years.map((year, i) => (
            <DropdownItem key={i} onClick={() => handleYearChange(year)}>{year}</DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default DateDropdown;
